import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { FocusShallow } from '../../coaching-tags/tags/tags.model';
import { TranslationKeyMap } from '../coaching-observation.i18n';
import { ObservationControllerMode } from '../observation-controller/controller.observation.model';
import { ObservationExtraOptions } from '../observation/observation-extra-options.model';
import {
    AllowedActions,
    EnabledActions,
    ObservationMode,
} from '../observation/observation.model';

export interface ObservationPopUpDialogData {
    userId: number;
    focus: FocusShallow;
    draftCommitmentId: string;
    commitmentId: number;
    extraOptions?: ObservationExtraOptions;
}

@Component({
    selector: '[cmpsObservationPopUp]',
    templateUrl: './observation-pop-up.component.html',
    host: {
        class: 'cmps-observation-pop-up',
        '[class.cmps-observation-pop-up--expanded]': '_dialogRef?.expanded',
    },
})
export class ObservationPopUpComponent {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _ObservationControllerMode = ObservationControllerMode;
    /** @private */ _ObservationMode = ObservationMode;
    /** @private */ _allowedActions: AllowedActions;
    /** @private */ _enabledActions: EnabledActions;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            ObservationPopUpComponent,
            any
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _options: ObservationPopUpDialogData,
    ) {}
}
